import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CmsParagraphComponent, CmsService, LanguageService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ShimanoBusinessTypeService } from 'src/app/service/businessType/shimano-business-type.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';

export interface ShimanoParagraphComponent extends CmsParagraphComponent {
  name: string;
  styleClass: string;
  typeCode: string;
  uid: string;
  uuid: string;
}

@Component({
  selector: 'app-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ParagraphComponent implements OnInit, OnDestroy {
  paragraphData$: Observable<ShimanoParagraphComponent> = this.component.data$;
  paragraph$: any;
  paragraphUid: string;
  discountTypeSubscription$: Subscription;
  discountType: string;
  hidden = false;
  PROTOCOL_REGEX_DOUBLEQUOTE: RegExp = /<a([^>]*?)href\s*=\s*(["]\/)/i;
  PROTOCOL_REGEX_SINGLEQUOTE: RegExp = /<a([^>]*?)href\s*=\s*([']\/)/i;
  bType: string;
  selectedCountry: string;
  lang: string;
  paragraphSub$: Subscription;

  constructor(
    public component: CmsComponentData<any>,
    private cmsService: CmsService,
    private componentService: ComponentService,
    private shimanoBusinessTypeService: ShimanoBusinessTypeService,
    private shimanoCountryService: ShimanoCountryService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {
    this.bType = this.businessType;
    this.selectedCountry = this.country;
    this.lang = this.activeLanguage;
  }

  get businessType(): string {
    let businessType: string;
    this.shimanoBusinessTypeService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (businessType = data));
    return businessType;
  }

  get country(): string {
    let country: string;
    this.shimanoCountryService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (country = data));
    return country;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (activeLanguage = data));
    return activeLanguage;
  }

  ngOnInit() {
    this.getParagraphData();

    this.discountTypeSubscription$ = this.componentService.discountType$.subscribe((discountType) => {
      this.discountType = discountType;
      this.cdr.detectChanges();
    });
  }

  getParagraphData() {
    this.paragraphSub$ = this.paragraphData$.pipe().subscribe((paragraph) => {
      if (paragraph !== null) {
        this.paragraph$ = of(paragraph);
        this.paragraphUid = '';
        if (paragraph.styleClass) {
          if (
            paragraph.styleClass !== 'undefined' &&
            paragraph.styleClass !== null &&
            paragraph.styleClass !== Object(paragraph.styleClass)
          ) {
            this.paragraphUid = paragraph.styleClass;
          }
        }
        this.cdr.detectChanges();
      }
    });
  }

  updateRelativePath(content: any) {
    if (typeof content !== 'undefined' && content !== null && content !== Object(content)) {
      let updatedContent = content
        .toString()
        .replace(this.PROTOCOL_REGEX_DOUBLEQUOTE, `<a href="/${this.bType}/${this.selectedCountry}/${this.lang}/`);
      updatedContent = updatedContent
        .toString()
        .replace(this.PROTOCOL_REGEX_SINGLEQUOTE, `<a href='/${this.bType}/${this.selectedCountry}/${this.lang}/`);
      return updatedContent;
    }
    return '';
  }

  get currentPageTemplate$(): Observable<string> {
    return this.cmsService.getCurrentPage().pipe(map((currentPage) => currentPage && currentPage.template));
  }

  ngOnDestroy() {
    if (this.discountTypeSubscription$) {
      this.discountTypeSubscription$.unsubscribe();
    }
    if (this.paragraphSub$) {
      this.paragraphSub$.unsubscribe();
    }
  }
}
